import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';

import {
  SSOErrorWrapper,
  SSOErrorHeader,
  SSOErrorSubheader,
  SSOErrorDescription,
  SSOErrorProviderLogo,
  SSOErrorActionsHeading,
  SSOErrorActionsList,
  SSOContactSupport,
} from '../styles';

export const DealertrackSsoError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SSOErrorWrapper>
      <div>
        <SSOErrorProviderLogo
          src={STATIC_IMAGE_URLS.ssoErrorDealertrackLogo}
          alt={t('components.ssoErrorPageDealertrack.logoAlt')}
        />
        <SSOErrorHeader>{t('components.ssoErrorPageDealertrack.title')}</SSOErrorHeader>
        <SSOErrorSubheader>{t('components.ssoErrorPageDealertrack.subheader')}</SSOErrorSubheader>
        <SSOErrorDescription>{t('components.ssoErrorPageDealertrack.description')}</SSOErrorDescription>
        <SSOErrorActionsHeading>{t('components.ssoErrorPageDealertrack.whatYouCanDo.heading')}</SSOErrorActionsHeading>
        <SSOErrorActionsList>
          <li>{t('components.ssoErrorPageDealertrack.whatYouCanDo.item1')}</li>
          <li>{t('components.ssoErrorPageDealertrack.whatYouCanDo.item2')}</li>
        </SSOErrorActionsList>
        <SSOContactSupport>
          <div>
            {t('components.ssoErrorPageDealertrack.contactSupport.text')}{' '}
            <a href={`mailto:${t('components.ssoErrorPageDealertrack.contactSupport.email')}`}>
              {t('components.ssoErrorPageDealertrack.contactSupport.email')}
            </a>{' '}
            {t('components.ssoErrorPageDealertrack.contactSupport.textPostfix')}
          </div>
        </SSOContactSupport>
      </div>
    </SSOErrorWrapper>
  );
};
